import { useRef, useState } from 'react'

import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { useToast } from '@/components/ui/use-toast'

interface ImageUploadProps {
  propertyId: number
  existingImagesCount: number
  onUploadComplete?: () => void
}

export function ImageUpload({
  propertyId,
  existingImagesCount,
  onUploadComplete,
}: ImageUploadProps) {
  const { toast } = useToast()
  const fileInputRef = useRef<HTMLInputElement>(null)
  const [uploading, setUploading] = useState(false)

  const handleUpload = async () => {
    if (!fileInputRef.current?.files) return

    const filesArray = Array.from(fileInputRef.current.files)
    if (filesArray.length + existingImagesCount > 25) {
      toast({
        title: 'Erro',
        description: 'Você só pode ter até 25 imagens por imóvel.',
        variant: 'destructive',
      })
      return
    }

    setUploading(true)

    const formData = new FormData()
    filesArray.forEach((file) => formData.append('files', file))

    // Parâmetros para associar as imagens ao imóvel no Strapi
    formData.append('ref', 'api::property.property')
    formData.append('refId', String(propertyId))
    formData.append('field', 'photos')

    try {
      const res = await fetch(
        `${import.meta.env.VITE_URL_ENDPOINT}/api/upload`,
        {
          method: 'POST',
          body: formData,
        },
      )

      if (!res.ok) throw new Error('Upload falhou')

      toast({
        title: 'Sucesso!',
        description: 'Imagens adicionadas com sucesso.',
      })

      // Chama o callback se fornecido para atualizar a listagem
      if (onUploadComplete) onUploadComplete()
    } catch (error) {
      toast({
        title: 'Erro no upload',
        description: 'Verifique as imagens e tente novamente.',
        variant: 'destructive',
      })
    } finally {
      setUploading(false)
      if (fileInputRef.current) fileInputRef.current.value = ''
    }
  }

  return (
    <div className="mt-6">
      <Label className="font-semibold text-gray-700">
        Adicionar Imagens (Máximo 25)
      </Label>
      <Input
        ref={fileInputRef}
        type="file"
        multiple
        accept="image/*"
        className="mt-2"
      />
      <Button onClick={handleUpload} disabled={uploading} className="mt-2">
        {uploading ? 'Enviando...' : 'Enviar Imagens'}
      </Button>
    </div>
  )
}
